module.exports = __webpack_public_path__ + "img/industrial-port-container-yard.fdd1f78f.png";